<script setup lang="ts">
import { Button } from '@/components/ui/button'
import { AutoForm } from '@/ui-plus/auto-form'
import { toTypedSchema } from '@vee-validate/zod'
import { useForm } from 'vee-validate'
import { z } from "zod";
import { useFormPlus } from '@/ui-plus/form/useFormPlus'
import { Loader2 } from 'lucide-vue-next'
import { dashboardApiClient } from '@api-client/dashboard';
import { onMounted } from 'vue';
import { currentWebsiteId } from '@partner-spa-vue/stores/MyWebsitesStore';
import { toast } from '@/ui-plus/sonner';
import { emailArraySchema } from "@lib/zod/EmailArray";

const schema = z.object({
    marketplaceNotificationEmails: emailArraySchema.optional(),
})

const form = useForm({
    validationSchema: toTypedSchema(schema),
})

const { isLoading, globalError, handleError, withSubmit } = useFormPlus(form);

const loadData = async () => {
    isLoading.value = true;
    console.log('loadData', currentWebsiteId.value);
    // // sleep 1 second
    // await new Promise(resolve => setTimeout(resolve, 1000));
    const { data, error } = await (await dashboardApiClient.website.geditors.website_contact_info[':id']['data.json'].$get({
        param: {
            id: currentWebsiteId.value ?? '',
        },
    })).json()
    if (error) {
        handleError(error, form);
    } else {
        if (data) {
            for (const key in data) {
                const typedKey = key as keyof typeof schema.shape;
                if (data[typedKey]) {
                    form.setFieldValue(typedKey, data[typedKey]);
                }
            }
        }
    }
    isLoading.value = false;
}

onMounted(() => {
    loadData();
})



async function onSubmit(values: z.infer<typeof schema>) {
    await withSubmit(async () => {
        const { data, error } = await (await dashboardApiClient.website.geditors.website_contact_info[':id'].$patch({
            param: {
                id: currentWebsiteId.value ?? '',
            },
            json: values
        })).json()
        if (error) {
            handleError(error, form);
        } else {
            // Success
            console.log('data', data);
            toast.success(`Saved`);
        }
    })
}

</script>

<template>
    <AutoForm class="space-y-6"
              :schema="schema"
              :form="form"
              :field-config="{
                marketplaceNotificationEmails: {
                    label: 'Marketing Team Notifications',
                    description: 'Marketplace related notifications, payouts, etc.',
                    inputProps: {
                        placeholder: 'marketplace-manager@example.com'
                    }
                },
            }"
              @submit="onSubmit">
        <div class="text-sm font-medium text-destructive"
             v-if="globalError">
            {{ globalError }}
        </div>
        <div>
            <Button type="submit"
                    :disabled="isLoading"
                    class="w-full my-6">
                <Loader2 v-if="isLoading"
                         class="animate-spin" />
                Save
            </Button>
        </div>
    </AutoForm>
</template>
